import { cn } from '@tg-hookah/ui';

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="loading"
      className={cn(
        'inline-block w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin',
        className,
      )}
    />
  );
}
